import { render, staticRenderFns } from "./LeaderboardTable.vue?vue&type=template&id=e78dfdc8&"
import script from "./LeaderboardTable.vue?vue&type=script&lang=js&"
export * from "./LeaderboardTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports